export const DEALATTRIBUTE_PERSONAL_URL = '/api/dealattribute/personal/';
